module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-chip",
    class: _vm.classNames,
    style: (_vm.style),
    on: {
      "mouseenter": _vm.onMouseenter,
      "mouseup": _vm.onMouseup,
      "mousedown": _vm.onMousedown,
      "mouseleave": _vm.onMouseleave,
      "touchstart": _vm.onTouchstart,
      "click": _vm.handleClick,
      "touchend": _vm.onTouchend,
      "touchcancel": _vm.onTouchend
    }
  }, [_vm._t("default"), _vm._v(" "), (_vm.showDelete && !_vm.disabled) ? _c('svg', {
    staticClass: "mu-chip-delete-icon",
    class: _vm.deleteIconClass,
    attrs: {
      "viewBox": "0 0 24 24"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleDelete.apply(null, arguments)
      }
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
    }
  })]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6170139a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/chip/chip.vue
// module id = 3747
// module chunks = 1